import React from 'react';
import styled from '@emotion/styled';
import OtherBankTypeRadio from '../radio/OtherBankTypeRadio';

const Base = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
`;

/**
 *  타금융사 할부조건 구분 contents 컴포넌트
 *  */
function OtherBankTypeContents(): JSX.Element {
  return (
    <Base>
      <OtherBankTypeRadio type={1} />
      <OtherBankTypeRadio type={2} />
    </Base>
  );
}

export default OtherBankTypeContents;
